"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  "facebook-messenger": {
    "name": "Facebook Messenger",
    "description": "",
    "tags": []
  },
  "google-adwords": {
    "name": "Google AdWords",
    "description": "",
    "tags": []
  },
  "google-gmail": {
    "name": "Google Gmail",
    "description": "",
    "tags": []
  },
  "google": {
    "name": "Google",
    "description": "",
    "tags": []
  },
  "hubspot-wordmark--light": {
    "name": "HubSpot wordmark (light)",
    "description": "",
    "tags": ["on-dark"]
  },
  "hubspot-wordmark": {
    "name": "HubSpot wordmark",
    "description": "",
    "tags": []
  },
  "office-365": {
    "name": "Office 365",
    "description": "",
    "tags": []
  },
  "outlook": {
    "name": "Outlook",
    "description": "",
    "tags": []
  },
  "rivaliq": {
    "name": "Rival IQ",
    "description": "",
    "tags": []
  },
  "salesforce": {
    "name": "Salesforce",
    "description": "",
    "tags": []
  },
  "shopify": {
    "name": "Shopify",
    "description": "",
    "tags": []
  },
  "slack-wordmark--dark": {
    "name": "Slack wordmark (dark)",
    "description": "",
    "tags": []
  },
  "slack-wordmark--light": {
    "name": "Slack wordmark (light)",
    "description": "",
    "tags": ["on-dark"]
  },
  "slack-wordmark": {
    "name": "Slack wordmark",
    "description": "",
    "tags": []
  },
  "slack": {
    "name": "Slack",
    "description": "",
    "tags": []
  },
  "stripe-wordmark": {
    "name": "Stripe wordmark",
    "description": "",
    "tags": []
  },
  "stripe": {
    "name": "Stripe",
    "description": "",
    "tags": []
  },
  "google-groups": {
    "name": "Google Groups",
    "description": "",
    "tags": []
  },
  "facebook": {
    "name": "Facebook",
    "description": "",
    "tags": []
  },
  "google-ads": {
    "name": "Google Ads",
    "description": "",
    "tags": []
  },
  "linkedin": {
    "name": "LinkedIn",
    "description": "",
    "tags": []
  }
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-images/static-2.112/js/logos-metadata.js
// module id = 274
// module chunks = 0